import { apiFetch } from '../client';

/**
 * Catálogos estáticos de ARCA para exportación (Factura E). El CUIT-país no se expone: lo resuelve
 * el server a partir de (país, tipo de entidad) al facturar; acá sólo van los tipos de entidad que
 * ARCA tiene para cada país.
 */
export type TipoEntidadExterior = 'juridica' | 'fisica' | 'otro';

export const TIPOS_ENTIDAD_EXTERIOR: { value: TipoEntidadExterior; label: string }[] = [
  { value: 'juridica', label: 'Persona Jurídica (empresa)' },
  { value: 'fisica', label: 'Persona Física' },
  { value: 'otro', label: 'Otro tipo de entidad' },
];

export type PaisExportacion = {
  /** Código de país destino de ARCA (WSFEX `Dst_cmp`). */
  codigo: string;
  nombre: string;
  tipos: TipoEntidadExterior[];
};

export type IncotermOpcion = { codigo: string; label: string };

export const PAISES_EXPORTACION_QUERY_KEY = ['catalogos', 'paises-exportacion'] as const;
export const INCOTERMS_QUERY_KEY = ['catalogos', 'incoterms'] as const;

export async function listPaisesExportacion(): Promise<PaisExportacion[]> {
  const res = await apiFetch<{ items: PaisExportacion[] }>('/api/catalogos/paises-exportacion');
  return res.items;
}

export async function listIncoterms(): Promise<IncotermOpcion[]> {
  const res = await apiFetch<{ items: IncotermOpcion[] }>('/api/catalogos/incoterms');
  return res.items;
}
